export const getEntityId = (entity) => entity?.id ?? entity?._id;

export const DEFAULT_DEVOPS_SHOWCASE = [
  {
    title: 'Docker & Containerisation',
    description: "Déploiement d'applications conteneurisées avec Docker",
  },
  {
    title: 'CI/CD Pipeline',
    description: "Mise en place de pipelines d'intégration et déploiement continus",
  },
  {
    title: 'Infrastructure as Code',
    description: "Gestion de l'infrastructure avec Terraform et Ansible",
  },
];

export const normalizeAbout = (about = {}) => ({
  description: '',
  image: '',
  yearsOfExperience: 0,
  projectsCompleted: 0,
  clientsSatisfied: 0,
  certifications: [],
  languages: [],
  ...about,
  certifications: about.certifications ?? [],
  languages: about.languages ?? [],
});
